import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, OnDestroy, OnInit, PLATFORM_ID, input } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'clever-meer',
    templateUrl: './meer.component.html',
    styleUrls: ['./meer.component.scss'],
    standalone: false
})
export class MeerComponent implements OnInit, OnDestroy {
    readonly mode = input<string>(undefined);
    readonly partner = input<Partner>(undefined);
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    meerblibk: boolean = false;
    meerseite: boolean = false;

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    selectBlink() {
        this.meerblibk = !this.meerblibk;
        this.hotelService.zommermitmeerblick(this.meerblibk, this.mode() !== 'home');
    }

    selectSeite() {
        this.meerseite = !this.meerseite;
        this.hotelService.meerseite(this.meerseite, this.mode() !== 'home');
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.meerseite = filter.meerseite;
            this.meerblibk = filter.zommermitmeerblick;
            this.cdr.detectChanges();
        });
    }
}
